import StatisticService from "../services/statisticService";
import {IGetHomesStatisticsReq} from "@source/api/models/statisticsModels";

export default class StatisticController {
  static async getUpdatesStatistic(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getUpdatesStatistic(data);
  }

  static async getNursingHomeActualStatistic(req: string) {
    return await StatisticService.getNursingHomeActualStatistic(req);
  }

  static async getFamilyMembersActivationStatistic(req: string) {
    return await StatisticService.getFamilyMembersActivationStatistic(req);
  }

  static async getEntryStatistic(req: string) {
    return await StatisticService.getEntryStatistic(req);
  }

  static async getEmployeeActivationStatistic(data:{ nursingHomes: string[]; totals: boolean}) {
    return await StatisticService.getEmployeeActivationStatistic(data);
  }

  static async getEmployeeTrainingProgressStatistic(data:{ nursingHomes: string[]; totals: boolean}) {
    return await StatisticService.getEmployeeTrainingProgressStatistic(data);
  }

  static async getEmployeeCreationByMonth(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getEmployeeCreationByMonth(data);
  }

  static async  downloadUnreadUpdateHistory(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.downloadUnreadUpdateHistory(data);
  }

  static async getAnnouncementCreationByMonth(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getAnnouncementCreationByMonth(data);
  }

  static async getAnnouncementTotalNumbers(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getAnnouncementTotalNumbers(data);
  }

  static async getUpdateCreationByPosition(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getUpdateCreationByPosition(data);
  }

  static async downloadUpdateReadTimings(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.downloadUpdateReadTimings(data);
  }

  static async downloadUpdateCreateTimings(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.downloadUpdateCreateTimings(data);
  }

  static async downloadUpdateReadTimingsAfterCreation(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.downloadUpdateReadTimingsAfterCreation(data);
  }

  static async downloadUpdateReadMoreThanOnce(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.downloadUpdateReadMoreThanOnce(data);
  }

  static async getUpdateCreationByCategory(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getUpdateCreationByCategory(data);
  }

  static async getTopByUpdateCreation(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    return await StatisticService.getTopByUpdateCreation(data);
  }

  static async getResidentsStatistic(data:{ nursingHomes: string[]; totals: boolean}) {
    return await StatisticService.getResidentsStatistic(data);
  }

  static async getNumbersStatistic(req: any) {
    return await StatisticService.getNumbersStatistic(req);
  }

  static async getSuperAdminStats(req: IGetHomesStatisticsReq) {
    return await StatisticService.getSuperAdminStats(req);
  }
}